import { Pipe, PipeTransform } from "@angular/core";

/**
 * Filtro que remove a tag de quebra de linha (<br/>) de um dado texto.
 */
@Pipe({
    name: "removeLineBreak"
})
export class RemoveLineBreakPipe implements PipeTransform {

    transform(input: string): string {
        return typeof input === "string" ? input.replace(/\<br\s*\/?>/g, "") : input;
    }
}
